import DatabaseModel from './DatabaseModel.js';
import CacheService from './Cache.js';

var ListadoCalendario = Object.create(DatabaseModel);

ListadoCalendario.model = 'listadoCalendario';
ListadoCalendario.modelFront = 'listadoCalendarios';

ListadoCalendario.calcular = function (params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/calcular/',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function (res) {
        return res;
    });
};

// Lanza la generación de resúmenes en segundo plano. Devuelve al instante: el progreso llega
// por SSE (ver ListadoCalendarioEvents.js), así que el usuario puede cerrar el modal.
ListadoCalendario.lanzarCalculo = function (params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/calcular/lanzar',
        method: 'POST',
        data: params.data
    }, false);
};

ListadoCalendario.cancelarCalculo = function () {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/calcular/cancelar',
        method: 'POST'
    }, false);
};

// Estado del job, para recuperar el hilo al volver a abrir el modal.
ListadoCalendario.estadoCalculo = function () {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/calcular/estado',
        method: 'GET'
    }, false);
};

ListadoCalendario.asignaConsumoReal = function (params) {
    var self = this;
    params = params || {};
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/asignaConsumoReal/',
        method: 'POST',
        data: params.data
    };
    return self.sendRequest(params, false).then(function (res) {
        return res;
    });
};

ListadoCalendario.importar = function(documento) {
    var self = this;
    var params = {
        url: self.server_movilidad + self.prefix + self.model + '/importar/',
        method: 'POST',
        data: documento
    };
    return self.sendRequest(params, false).then((res) => {
        CacheService.clearCache(self.model);
        return res;
    }).catch((error) => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
    });
}

export default ListadoCalendario;